import { defineMessages } from "react-intl";

const messages = defineMessages({
  autoFilledRequiredRelationshipFieldMissedTooltip: {
    id: "email.creation.activitiesCreateModal.autoFilledRequiredRelationshipFieldMissedTooltip",
    defaultMessage:
      "There is a required relationship field that cannot be used because altering its value could create inaccurate relationships when adding records in bulk. Please try emailing only one recipient at a time or changing your layout..",
    description: "Tooltip for send button when autofilled relationship field is required",
  },
  autoFilledWithDealRelationship: {
    id: "email.creation.activitiesCreateModal.autoFilledWithDealRelationship",
    defaultMessage: "Autofilled with deal’s relationship",
    description: "Auto-filled with deal relationship label in activity creation modal",
  },
  autoFilledWithDealRelationshipIfOnlyOneRelationshipExists: {
    id: "email.creation.activitiesCreateModal.autoFilledWithDealRelationshipIfOnlyOneRelationshipExists",
    defaultMessage: "Autofilled with deal’s relationship if one exists.",
    description:
      "Auto-filled with deal relationship if only one relationship exists label in activity creation modal",
  },
  autoFilledWithRecipient: {
    id: "email.creation.activitiesCreateModal.autoFilledWithRecipient",
    defaultMessage: "Auto filled with recipient",
    description: "Auto-filled with recipient label in activity creation modal",
  },
  autoFilledWithRecipientRelationship: {
    id: "email.creation.activitiesCreateModal.autoFilledWithRecipientRelationship",
    defaultMessage: "Autofilled with recipient’s relationship",
    description: "Auto-filled with recipient relationship label in activity creation modal",
  },
  autoFilledWithRecipientRelationshipIfOnlyOneRelationshipExists: {
    id: "email.creation.activitiesCreateModal.autoFilledWithRecipientRelationshipIfOnlyOneRelationshipExists",
    defaultMessage: "Autofilled with recipient’s relationship if only one relationship exists.",
    description:
      "Auto-filled with recipient relationship if only one relationship exists label in activity creation modal",
  },
  autoFilledWithSelectedDeals: {
    id: "email.creation.activitiesCreateModal.autoFilledWithSelectedDeals",
    defaultMessage: "Autofilled with selected deals",
    description: "Auto-filled with selected deals label in activity creation modal",
  },
  autoFillingRelationshipFieldDisabledTooltip: {
    id: "email.creation.activitiesCreateModal.autoFillingRelationshipFieldDisabledTooltip",
    defaultMessage:
      "This field is disabled because its value could create inaccurate relationships when adding records in bulk.",
    description: "Tooltip for auto filling relationship field when it is disabled",
  },
});

export default messages;
